import { makeAutoObservable } from 'mobx';

import type { RootStore } from 'store/RootStore';
import { OptionBase } from 'store/fileds/SelectField';

import { Favorites } from './Favorites';
import { LoadsWithAuctions } from './LoadsWithAuctions';
import { LoadsWithOffers } from './LoadsWithOffers';

export class FollowedLoads {
  readonly #root: RootStore;
  favorites: Favorites;
  loadsWithOffers: LoadsWithOffers;
  loadsWithAuctions: LoadsWithAuctions;

  constructor(root: RootStore) {
    this.#root = root;
    this.favorites = new Favorites(this.#root);
    this.loadsWithOffers = new LoadsWithOffers(this.#root);
    this.loadsWithAuctions = new LoadsWithAuctions(this.#root);

    makeAutoObservable(this);
  }

  get count() {
    return this.favorites.count + this.loadsWithOffers.count + this.loadsWithAuctions.count;
  }

  setItemsPerPage = (option: OptionBase<number>) => {
    this.#root.ui.pagination.setFollowedLoadsPerPage(option);
    this.updateActiveLoads();
  };

  updateActiveLoads = () => {
    const updateByTab = {
      onlyWithFavorites: this.favorites.repaginate,
      onlyWithOffers: this.loadsWithOffers.updateLoads,
      onlyWithAuctions: this.loadsWithAuctions.updateLoads,
    };

    return updateByTab[this.#root.ui.followedLoadsTab.data]();
  };
}
